import { render } from "./InputText.vue?vue&type=template&id=3a52d7bf&scoped=true&ts=true"
import script from "./InputText.vue?vue&type=script&lang=ts"
export * from "./InputText.vue?vue&type=script&lang=ts"

import "./InputText.vue?vue&type=style&index=0&id=3a52d7bf&lang=scss&scoped=true"

import exportComponent from "E:\\vue_test\\vue-gpt-sample\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a52d7bf"]])

export default __exports__